import { inject } from "@angular/core";
import { Routes } from "@angular/router";
import { Matcher } from "@zaeper/angular-core-lib";

import { languageResolverServiceInjectionToken } from "../services/language/languageResolverServiceInjectionToken";
import { dictionaryResolverServiceInjectionToken } from "../services/dictionary/dictionary-resolver-service-injection-token";
import { authenticationGuardInjectionToken } from "./guards/session/authentication-guard-injection-token";
import { currentUserResolverInjectionToken } from "./resolvers/session/current-user-resolver-injection-token";
import {
  quickAccessResourcesResolverInjectionToken
} from "./resolvers/session/quick-access-resources-resolver-injection-token";

import { ReceiverPreviewerPageComponent } from "../pages/receiver-previewer-page/receiver-previewer-page.component";
import { CloudsOverviewPageComponent } from "../pages/clouds-overview-page/clouds-overview-page.component";
import { GroupsOverviewPageComponent } from "../pages/groups-overview-page/groups-overview-page.component";
import { ReceiversOverviewPageComponent } from "../pages/receivers-overview-page/receivers-overview-page.component";
import { FeaturesOverviewPageComponent } from "../pages/features-overview-page/features-overview-page.component";
import { CompanyManagementPageComponent } from "../pages/company-management-page/company-management-page.component";
import { UserSettingsPageComponent } from "../pages/user-settings-page/user-settings-page.component";
import { PaymentOverviewPageComponent } from "../pages/payment-overview-page/payment-overview-page.component";
import { SaveLocalstoragePageComponent } from "../pages/save-localstorage-page/save-localstorage-page.component";
import { AppOutletComponent } from "../outlets/app-outlet/app-outlet.component";
import { StoreRoutingModule } from "@zaeper/angular-application-store-lib";

const availableLanguages: [string, string] = ["de", "en"];

export const routes: Routes = [
  {
    path: "",
    redirectTo: `${availableLanguages[0]}`,
    pathMatch: "full"
  },
  {
    path: "save-localstorage",
    pathMatch: "full",
    component: SaveLocalstoragePageComponent
  },
  {
    path: "",
    component: AppOutletComponent,
    pathMatch: "prefix",
    canActivateChild: [() => inject(authenticationGuardInjectionToken).isLoggedIn()],
    children: [
      {
        matcher: Matcher.matchLanguage(availableLanguages),
        pathMatch: "prefix",
        resolve: {
          language: languageResolverServiceInjectionToken,
          dictionaries: dictionaryResolverServiceInjectionToken,
          currentUser: () => inject(currentUserResolverInjectionToken).getCurrentUser(),
          quickAccessResources: () => inject(quickAccessResourcesResolverInjectionToken).getQuickAccessResources()
        },
        children: [
          {
            path: "",
            pathMatch: "full",
            component: ReceiverPreviewerPageComponent
          },
          {
            path: "",
            pathMatch: "prefix",
            children: [
              {
                path: "clouds",
                pathMatch: "full",
                component: CloudsOverviewPageComponent
              },
              {
                path: "clouds",
                pathMatch: "prefix",
                children: [
                  {
                    pathMatch: "prefix",
                    matcher: Matcher.matchId("cloudId"),
                    children: [
                      {
                        path: "groups",
                        pathMatch: "full",
                        component: GroupsOverviewPageComponent
                      },
                      {
                        path: "groups",
                        pathMatch: "prefix",
                        children: [
                          {
                            pathMatch: "prefix",
                            matcher: Matcher.matchId("groupId"),
                            children: [
                              {
                                path: "receivers",
                                pathMatch: "full",
                                component: ReceiversOverviewPageComponent
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                path: "store",
                loadChildren: () => StoreRoutingModule
              },
              {
                path: "company",
                pathMatch: "full",
                component: CompanyManagementPageComponent
              },
              {
                path: "features",
                pathMatch: "full",
                component: FeaturesOverviewPageComponent
              },
              {
                path: "user-settings",
                pathMatch: "full",
                component: UserSettingsPageComponent
              },
              {
                path: "payment-overview",
                pathMatch: "full",
                component: PaymentOverviewPageComponent
              }
            ]
          }
        ]
      }
    ]
  }
];
